// extracted by mini-css-extract-plugin
module.exports = {"setting":"setting_setting-E1BpD","fieldset":"setting_fieldset-1rC7v","fieldsetLabel":"setting_fieldsetLabel-3hS20","dangerZone":"setting_dangerZone-3jaqz"};